/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { CategoryResult } from "./category-result"

export interface Result {
  noteId: string
  categoryResults: Array<CategoryResult>
  version: number
  involvementProfileV2?: ResultInvolvementProfileV2Enum
  cornerstoneCategories: Array<ResultCornerstoneCategoriesEnum>
}

export const ResultInvolvementProfileV2Enum = {
  NEGATIVE_IMPACT: "NEGATIVE_IMPACT",
  NEUTRAL_IMPACT: "NEUTRAL_IMPACT",
  POSITIVE_IMPACT: "POSITIVE_IMPACT"
} as const

export type ResultInvolvementProfileV2Enum =
  (typeof ResultInvolvementProfileV2Enum)[keyof typeof ResultInvolvementProfileV2Enum]
export const ResultCornerstoneCategoriesEnum = {
  EMPLOYMENT: "EMPLOYMENT",
  TERRITORY: "TERRITORY",
  SOCIAL: "SOCIAL",
  ENVIRONMENT: "ENVIRONMENT",
  GOVERNANCE: "GOVERNANCE",
  OTHER: "OTHER"
} as const

export type ResultCornerstoneCategoriesEnum =
  (typeof ResultCornerstoneCategoriesEnum)[keyof typeof ResultCornerstoneCategoriesEnum]
